import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=4f3619b1&scoped=true"
import script from "./orderResult.vue?vue&type=script&lang=js"
export * from "./orderResult.vue?vue&type=script&lang=js"
import style0 from "./orderResult.vue?vue&type=style&index=0&id=4f3619b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3619b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3619b1')) {
      api.createRecord('4f3619b1', component.options)
    } else {
      api.reload('4f3619b1', component.options)
    }
    module.hot.accept("./orderResult.vue?vue&type=template&id=4f3619b1&scoped=true", function () {
      api.rerender('4f3619b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components-cool/orderResult.vue"
export default component.exports